import styled, { css, createGlobalStyle } from 'styled-components';
import { baseText } from 'core/styles';
import { getColor, typeScale, spacingUnits, StyleVars } from 'core/utils';

export const BannerContainer = styled.div`
	height: 50px;
	display: flex;
	flex-direction: column;
	justify-content: center;

	/* sold_out styling: */
	background: ${getColor("albescentWhite")};
	color: ${getColor("yellowMetal")};
`;

export const BannerMessage = styled.div`
	padding: 0 20px;
	line-height: 22px;
	letter-spacing: 0;
	width: 100%;
	font-size: 16px;
	font-weight: 600;
	text-align: center;
`;
